import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { ScrollSpy } from "bootstrap"

import  Circle  from '../assets/ds-circle.svg';
import  Arrow  from '../assets/arrow.svg';
import  Small  from '../assets/arrow-small.svg';

import AnimatedOrbit from "../components/AnimatedOrbit";


const IndexPage = () => (
  <Layout> 
    <Seo title="digital smash" />
    
      <section id="home" className="px-md-2 py-md-2 my-md-5 px-2 py-2 my-2">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h1>
                <span className="top">Web</span>
                <span className="sub">& Digital</span>
              </h1>
              <div className="col-md-10">
                <p className="lead mb-4">Bold ideas deserve bold execution. From design to development, creating digital experiences that captivate and perform.</p>
              </div>
              <div className="col-md-12">
                <p className="mb-5">
                  Every project starts with a <span className="warning"><Small />vision</span> and turns into something extraordinary. Mobile-first, fully responsive, and tailored to your goals, each solution is crafted to leave an impression that lasts.
                </p>
              </div>
            </div>
            <div className="teaser d-none d-sm-block">
              <a href="#contact">
              <span className="tease-text">
                get in touch
              </span>
              </a>
              <div className="circle">
                <a href="mailto:info@digital-smash.de">
                  <Circle className="u--rotate" />
                </a>
              </div>
              <div className="arrow">
                <a href="mailto:info@digital-smash.de">
                <Arrow className=""/>
                {/* info@digital-smash.de */}
                </a>
              </div>
            </div>
            
            </div>
          </div>
        </section>
        <section id="services" className="px-md-2 py-md-5 my-md-5 px-2 py-2 my-2 text-dark">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <h2>Services</h2>
                <p className="lead mb-4">From first idea to launch day, I’m by your side to turn bold visions into seamless digital experiences. Here’s what I can create with you:</p>
              </div>
            </div>
            
            <div className="card-group">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">01. Creative</h5>
                  <h3 className="card-text">We believe that no idea is off-limits, we strive to be unique and are not afraid to take risks.</h3>
                  <p className="card-text">
                    <small className="text-body-secondary">Creativity can come in all shapes and forms, not just design. This mindset flows through all facets of the way we work. "No" should rarely be an acceptable answer.</small>
                  </p>
                  <ul className="list-unstyled">
                  <li><Small />User Experience</li>
                  <li><Small />Interface Design</li>
                  <li><Small />UX Research</li>
                  <li><Small />Screendesign</li>
                </ul>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">02. Collaborative</h5>
                  <h3 className="card-text">We work like part of your team. Our strong relationships drive success and outcomes.</h3>
                  <p className="card-text">
                    <small className="text-body-secondary">By supporting each other and sharing knowledge we create long-term relationships based on trust. We're honest in our approach, take pride in our work, and we celebrate the wins together.</small>
                  </p>
                  <ul className="list-unstyled">
                  <li><Small />Frontend</li>
                  <li><Small />Jamstack</li>
                  <li><Small />Web App</li>
                  <li><Small />Responsive Design</li>
                  <li><Small />Responsive Design</li>
                </ul>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">03. Compassionate</h5>
                  <h3 className="card-text">We do the right thing, even when no one is watching. We treat each project like it's our own.</h3>
                  <p className="card-text">
                    <small className="text-body-secondary">We built our business through word of mouth and happy repeat clients. By always delivering more than what's expected, we bring value beyond the contract.</small>
                  </p>
                  <ul className="list-unstyled">
                  <li><Small />Agile Approach</li>
                  <li><Small />Scrum Method</li>
                  <li><Small />Projekt Management</li>
                  <li><Small />Storytelling</li>
                </ul>
                </div>
              </div>
            </div>

          </div>
      </section>
      <section id="process" className="py-md-5 py-3">
  <div className="container">
    <div className="row">
      <div className="col-md-8">
        <h2>Process</h2>
        <p className="lead mb-4">Clear steps. Real progress. Here’s how we bring ideas to life:</p>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <ol className="process-list">
          <li><strong>01. Discovery</strong> — Understanding your vision, goals, and users.</li>
          <li><strong>02. Design Direction</strong> — Crafting flows, wireframes, and moodboards that set the path.</li>
          <li><strong>03. Validation</strong> — Testing ideas early, refining with real feedback.</li>
          <li><strong>04. UI Design</strong> — Shaping every pixel for clarity, beauty, and usability.</li>
          <li><strong>05. Implementation</strong> — Developing clean, scalable, high-performance solutions.</li>
        </ol>
      </div>
    </div>
  </div>
</section>
{/* <section className="py-md-5 py-3 bg-light">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <AnimatedOrbit />
      </div>
    </div>
  </div>
  
</section>
<section id="toolbox" className="py-md-5 py-3 bg-light">
  <div className="container">
    <div className="row">
      <div className="col-md-8">
        <h2>Toolbox</h2>
        <p className="lead mb-4">The right tools make all the difference. Here's what I work with daily:</p>
      </div>
    </div>
    <div className="row g-4">
      <div className="col-6 col-md-3 text-center">
        <img src="/path/to/gatsby-logo.svg" alt="Gatsby" height="40" />
        <p className="mt-2">Gatsby</p>
      </div>
      <div className="col-6 col-md-3 text-center">
        <img src="/path/to/react-logo.svg" alt="React" height="40" />
        <p className="mt-2">React</p>
      </div>
      <div className="col-6 col-md-3 text-center">
        <img src="/path/to/contentful-logo.svg" alt="Contentful" height="40" />
        <p className="mt-2">Contentful</p>
      </div>
      <div className="col-6 col-md-3 text-center">
        <img src="/path/to/typo3-logo.svg" alt="TYPO3" height="40" />
        <p className="mt-2">TYPO3</p>
      </div>
      
    </div>
  </div>
</section> */}




  </Layout>

)
export default IndexPage
